import * as angular from "angular";
import {AssignProgramsController} from "./assign-programs.controller";
const templateUrl = require("./assign-programs.html");

export const assignPrograms: angular.IComponentOptions = {
    templateUrl: templateUrl,
    controller: AssignProgramsController,
    controllerAs: "vm",
    bindings: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/assign-programs/assign-programs.ts
 **/